var render = function () {
  var _vm$response, _vm$response2, _vm$response2$banner, _vm$response3, _vm$response4, _vm$response5, _vm$response6;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-page"
  }, [(_vm$response = _vm.response) !== null && _vm$response !== void 0 && _vm$response.filter ? _c('CategorySidebar', {
    attrs: {
      "list": _vm.response.filter
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "category-page__content"
  }, [(_vm$response2 = _vm.response) !== null && _vm$response2 !== void 0 && (_vm$response2$banner = _vm$response2.banner) !== null && _vm$response2$banner !== void 0 && _vm$response2$banner.src ? _c('CatalogWideBanner', {
    staticClass: "mb-20",
    attrs: {
      "link": ("/sales/" + (_vm.response.banner.code) + "/"),
      "src": _vm.response.banner.src.desk,
      "alt": _vm.response.banner.name
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.bannerSelect.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "category-page__title"
  }, [_vm._v("\n      " + _vm._s((_vm$response3 = _vm.response) === null || _vm$response3 === void 0 ? void 0 : _vm$response3.name) + "\n      "), _c('span', {
    staticClass: "category-page__product-count"
  }, [_vm._v(_vm._s(_vm.declOfNumGoods))])]), _vm._v(" "), (_vm$response4 = _vm.response) !== null && _vm$response4 !== void 0 && _vm$response4.children ? _c('div', {
    staticClass: "category-page__content-row"
  }, [_c('CategoriesGrid', {
    attrs: {
      "list": _vm.response.children
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm$response5 = _vm.response) === null || _vm$response5 === void 0 ? void 0 : _vm$response5.sliders, function (slider, index) {
    return [slider.list.length ? _c('div', {
      key: slider.title,
      staticClass: "category-page__slider"
    }, [_c('h2', {
      staticClass: "category-page__content-row-title"
    }, [_vm._v("\n          " + _vm._s(slider.title) + "\n        ")]), _vm._v(" "), _c('ViewportToogle', {
      staticClass: "category-page__content-row mb-30",
      scopedSlots: _vm._u([{
        key: "desktop",
        fn: function () {
          return [_c('RowSliderNew', {
            attrs: {
              "list": slider.list,
              "offset-between-elements": 10
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (_ref) {
                var _vm$_b;

                var el = _ref.el;
                return [_c('TSProductCard', _vm._b({
                  key: el.id,
                  staticClass: "row-slider__product",
                  attrs: {
                    "product": el,
                    "compact": true,
                    "data-e2e": "product-card",
                    "data-e2e-product-card-id": el.id
                  },
                  on: {
                    "product-select": function ($event) {
                      var _slider$title;

                      return _vm.$emitter.emit('product-select', {
                        product: el,
                        listName: (_slider$title = slider.title) !== null && _slider$title !== void 0 ? _slider$title : '',
                        index: index
                      });
                    },
                    "remove-favorite": _vm.removeFavorite
                  }
                }, 'TSProductCard', (_vm$_b = {}, _vm$_b[("data-e2e-product-card-" + (el.id))] = el.id, _vm$_b), false))];
              }
            }], null, true)
          })];
        },
        proxy: true
      }, {
        key: "mobile",
        fn: function () {
          return [_c('TSProductPromo', {
            attrs: {
              "items": slider.list,
              "product-align": index % 2 ? 'left' : 'right',
              "count": _vm.getCountProduct(index + 1)
            },
            on: {
              "link-click": function ($event) {
                var _slider$title2;

                return _vm.$emitter.emit('product-select', Object.assign({}, $event, {
                  listName: (_slider$title2 = slider.title) !== null && _slider$title2 !== void 0 ? _slider$title2 : ''
                }));
              }
            }
          })];
        },
        proxy: true
      }], null, true)
    })], 1) : _vm._e()];
  }), _vm._v(" "), (_vm$response6 = _vm.response) !== null && _vm$response6 !== void 0 && _vm$response6.brand ? _c('div', {
    staticClass: "category-page__slider"
  }, [_c('RowSliderNew', {
    staticClass: "row-slider_brand",
    attrs: {
      "list": _vm.response.brand,
      "offset-between-elements": 15
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var el = _ref2.el;
        return [_c('BrandEl', {
          key: el.id,
          attrs: {
            "brand": el,
            "size": "m"
          }
        })];
      }
    }], null, false, 1954042265)
  })], 1) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }